
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1857',
  depVersions: {
  "customer-portal-app": "static-1.1857",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "data-fetching-client": "static-1.9546",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.416",
  "growth-payments-core": "static-1.24927",
  "head-dlb": "static-1.4884",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5462",
  "hs-test-utils": "static-1.7878",
  "hub-http": "static-1.6087",
  "hub-http-shared-msw-handlers": "static-1.9645",
  "hubspot-dlb": "static-2.1806",
  "hubspot-prosemirror": "static-1.17811",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11312",
  "I18n": "static-7.1596",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6339",
  "payment-link-components": "static-1.23125",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6822",
  "quartz-core": "static-1.6041",
  "react": "static-7.182",
  "react-colorpicker": "static-2.10080",
  "react-dlb": "static-1.74",
  "react-utils": "static-2.5238",
  "rich-text-lib": "static-1.19594",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17765",
  "ui-components-test-utils": "static-1.5450",
  "UIComponents": "static-3.8259",
  "foundations-assets": "static-1.4709",
  "foundations-components": "static-1.7652",
  "foundations-theming": "static-1.4279",
  "foundations-theming-specialty": "static-1.1995",
  "framer-motion": "static-1.69",
  "history": "static-4.47",
  "metrics-js": "static-1.9436",
  "PortalIdParser": "static-2.377",
  "portals-platform-lib": "static-1.649",
  "quartz-config": "static-1.600",
  "quartz-routing": "static-1.252",
  "quick-fetch": "static-1.3803",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16519",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.8014",
  "styled-components": "static-2.85",
  "tanstack-table": "static-1.52",
  "ui-addon-draggable": "static-3.4637",
  "ui-addon-react-router-dom": "static-1.9414",
  "usage-tracker": "static-1.7204",
  "usage-tracker-anonymous": "static-1.5621",
  "usage-tracker-core": "static-1.7054",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5433",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3295",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3099",
  "quartz-webpack": "static-1.3046",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.79",
  "customer-data-objects": "static-1.7523",
  "frontend-preferences-client": "static-1.7793",
  "laboratory-lib": "static-3.7028",
  "onboarding-scopes": "static-1.6332",
  "rpc-client-utils": "static-1.4513",
  "ui-addon-opt": "static-4.8253",
  "HeadJS": "static-2.729",
  "hs-test-utils-bend-plugin": "static-1.2989",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "ts-schema": "static-1.3970",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7545",
  "cssUtils": "static-1.761",
  "customer-data-ui-utilities": "static-1.9693",
  "HubStyle": "static-2.11620",
  "knowledge-content-types": "static-1.8427",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.497",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.485",
  "ui-addon-emoji-picker": "static-1.9756",
  "ui-addon-i18n": "static-1.11015",
  "ui-business-units-lib": "static-1.8902",
  "ui-shepherd-react": "static-3.10015",
  "video-components-external": "static-1.10801",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "jasmine": "static-4.4195",
  "commerce-tours-lib": "static-1.5833",
  "customer-data-properties": "static-1.51012",
  "getting-started-shared-tasks": "static-1.18079",
  "growth-onboarding-reliability": "static-1.4955",
  "onboarding-tours": "static-1.16360",
  "reference-resolvers-lite": "static-1.7955",
  "sales-checkout-service-client": "static-1.3537",
  "ui-addon-iframeable": "static-1.8916",
  "user-context": "static-1.4969",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.814",
  "hubspotter-http": "static-1.4543",
  "icons": "static-2.636",
  "mobile-manifest-mixins": "static-1.504",
  "module-federation": "static-1.20",
  "quartz-auth": "static-1.497",
  "quartz-head": "static-1.487",
  "quartz-test": "static-1.497",
  "quartz-tracking": "static-1.201",
  "ui-fonts": "static-1.574",
  "usage-tracker-container": "static-1.7194",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9296",
  "data-token-picker": "static-1.16166",
  "FileManagerLib": "static-1.38779",
  "property-translator": "static-1.5277",
  "atom": "static-1.4939",
  "merchandise-lib": "static-1.261",
  "purchase-motions-components": "static-1.5600",
  "salesImages": "static-1.522",
  "SharedI18nStrings": "static-1.181",
  "foundations-components-test-utils": "static-1.5135",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.96",
  "ui-images": "static-2.1121",
  "bend-plugin-foundations-components": "static-1.3921",
  "floating-ui": "static-1.53",
  "react-aria": "static-1.63",
  "trellis-assets": "static-1.1410",
  "bend-plugin-foundations-theming": "static-1.2762",
  "foundations-theming-base": "static-1.3264",
  "stylex": "static-1.29",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5618",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4343",
  "react-flip-move": "static-1.67",
  "bender-build-tools": "static-1.3025",
  "inbound-db-properties-service-client": "static-1.3736",
  "superstore": "static-1.4638",
  "chirp-fetch": "static-1.1752",
  "feedback-loader": "static-1.29015",
  "ai-components-ui-library": "static-1.8562",
  "ui-addon-video-player": "static-1.8565",
  "ui-coaching-tips": "static-1.28133",
  "sassPrefix": "static-1.153",
  "react-dnd-compat": "static-1.4489",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2361",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8034",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4520",
  "content-media-composition-data-lib": "static-1.11740",
  "content-media-compositions": "static-2.15747",
  "idb-keyval": "static-1.41",
  "immer": "static-1.33",
  "immerable": "static-1.4023",
  "magpie-lib": "static-1.5463",
  "magpie-types": "static-1.4923",
  "media-bridge-lib": "static-1.18689",
  "video-data-lib": "static-1.34459",
  "commerce-products-lib": "static-1.9040",
  "crm-message-bus": "static-1.42578",
  "growth-data-modal": "static-1.5229",
  "hubspot-apollo-client": "static-1.4748",
  "onboarding-tours-client": "static-1.4574",
  "calling-global-api": "static-1.63945",
  "calling-internal-common": "static-1.31169",
  "calling-lifecycle-internal": "static-1.65327",
  "calling-lifecycle-messages": "static-1.57621",
  "conditional-properties-service-client": "static-1.3688",
  "crm-links": "static-1.6140",
  "customer-data-objects-ui-components": "static-1.12882",
  "customer-data-property-utils": "static-1.7949",
  "external-options-client-types": "static-1.4049",
  "file-manager-components": "static-1.23139",
  "framework-data-schema-resolvers": "static-1.6743",
  "google-libphonenumber": "static-1.35",
  "hs-entities": "static-1.555",
  "inbound-db-meta-service-client": "static-1.3484",
  "inbounddb-objects-service-types": "static-1.4113",
  "meetings-icalendar-utils-lib": "static-1.501",
  "multi-currency-client-types": "static-1.3580",
  "object-builder-ui-client": "static-1.48242",
  "pipeline-validation-client-types": "static-1.3854",
  "property-value-citations": "static-1.1626",
  "pulse": "static-1.396",
  "smart-property-lib": "static-1.6225",
  "tiered-pricing": "static-1.940",
  "ui-addon-form-validation": "static-1.10862",
  "growth-onboarding-confetti": "static-1.2941",
  "growth-onboarding-next-action-utils": "static-1.1485",
  "navigation-components": "static-1.17509",
  "onboarding-tours-utils": "static-1.426",
  "ui-shepherd-tracker": "static-1.7396",
  "ui-universal-auth": "static-1.8790",
  "batch-promise": "static-1.1420",
  "navigation-messaging": "static-1.6836",
  "getting-started-shared-tasks-store": "static-1.17197",
  "hubspotter-http-shared-msw-handlers": "static-1.9643",
  "usage-tracker-session-replay": "static-1.4890",
  "audio-components": "static-1.5710",
  "FileManagerCore": "static-1.38638",
  "FileManagerImages": "static-1.36290",
  "video-components": "static-1.12804",
  "foundations-components-legacy": "static-1.677",
  "growth-monetization-service-types": "static-1.4368",
  "nav-client-types": "static-1.2226",
  "purchase-motions-api": "static-1.5603",
  "self-service-api": "static-1.10111",
  "signup-constants": "static-1.18553",
  "signup-ui-url-generator": "static-2.7904",
  "trials-service-types": "static-1.3769",
  "usage-tracker-public": "static-1.7015",
  "chatspot-core": "static-1.20634",
  "ContentUtils": "static-1.67841",
  "copilot-toolkit": "static-1.10723",
  "growth-onboarding-feedback-components": "static-1.6450",
  "reactive-lib": "static-1.594",
  "simple-logging-lib": "static-1.2919",
  "commerce-permissions": "static-1.632",
  "customer-data-tracking": "static-1.6751",
  "products-iframe-lib": "static-1.7529",
  "products-ui-components-shared-msw-handlers": "static-1.10027",
  "hubspot-apollo-cache": "static-1.207",
  "calling-error-reporting": "static-1.31175",
  "shared-worker-versioning": "static-1.10908",
  "calling-usage-tracker": "static-1.6410",
  "voice-sms-access-library": "static-1.453",
  "conversations-skeleton-state": "static-1.7118",
  "location-customization-utils-lib": "static-1.8783",
  "crm-pipelines-api-client-types": "static-1.4031",
  "framework-builder-read-service-client": "static-1.3898",
  "framework-data-schema-quick-fetch": "static-1.6648",
  "persist-promise": "static-1.3577",
  "directed-graph": "static-1.808",
  "event-emitter": "static-1.816",
  "fast-json-patch": "static-1.60",
  "breeze-intelligence-kit": "static-1.5419",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9728",
  "fsm": "static-1.3600",
  "policy-lib": "static-1.6648",
  "react-tinymce": "static-1.54823",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9791",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53949",
  "tinymce-plugins": "static-1.57063",
  "tinymce-themes": "static-1.55919",
  "growth-onboarding-next-action-components": "static-1.1513",
  "user-context-client": "static-1.4482",
  "unified-auth-core-lib": "static-1.585",
  "amplitude-session-replay-browser": "static-1.57",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4400",
  "video-embed": "static-1.35293",
  "content-icons-ui": "static-1.2185",
  "social-insights-client-types": "static-1.21604",
  "eligibility-engine-service-types": "static-1.3050",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4678",
  "integrations-lib": "static-1.15642",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4135",
  "calling-orchestration-schema": "static-1.35230",
  "crm-record-cards-service-types": "static-1.3507",
  "highcharts": "static-8.101",
  "trellis-story-utils": "static-1.4389",
  "storybook-react": "static-1.30",
  "hub-http-contrib": "static-1.2912",
  "interframe": "static-3.4632",
  "tinymce-data": "static-1.40034",
  "ui-addon-sales-email": "static-1.5082",
  "codemirror": "static-5.92",
  "layout-dnd-components": "static-1.12178",
  "layout-dnd-utils": "static-1.11153",
  "react-codemirror": "static-1.10495",
  "ui-brand-identity-lib": "static-1.14402",
  "NamespacedHubStyle": "static-2.8960",
  "outpost": "static-1.4068",
  "flux-actions": "static-1.322",
  "integrations-error-boundary-lib": "static-1.13057",
  "integrations-tracking-lib": "static-1.5461",
  "native-integrations-shared-strings": "static-1.7656",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10243",
  "rxjs": "static-5.10",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67916",
  "layout-data-lib": "static-1.9478",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2871",
  "advanced-menus-core": "static-1.14915",
  "advanced-menus-lib": "static-1.11883",
  "ExportDialog": "static-6.10258",
  "ui-memberships-settings-lib": "static-1.33640",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14914",
  "simple-menus-lib": "static-1.16431"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1857",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "data-fetching-client": "/data-fetching-client/static-1.9546",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.416",
  "growth-payments-core": "/growth-payments-core/static-1.24927",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5462",
  "hs-test-utils": "/hs-test-utils/static-1.7878",
  "hub-http": "/hub-http/static-1.6087",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9645",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17811",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11312",
  "I18n": "/I18n/static-7.1596",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6339",
  "payment-link-components": "/payment-link-components/static-1.23125",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6822",
  "quartz-core": "/quartz-core/static-1.6041",
  "react": "/react/static-7.182",
  "react-colorpicker": "/react-colorpicker/static-2.10080",
  "react-dlb": "/react-dlb/static-1.74",
  "react-utils": "/react-utils/static-2.5238",
  "rich-text-lib": "/rich-text-lib/static-1.19594",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17765",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5450",
  "UIComponents": "/UIComponents/static-3.8259",
  "foundations-assets": "/foundations-assets/static-1.4709",
  "foundations-components": "/foundations-components/static-1.7652",
  "foundations-theming": "/foundations-theming/static-1.4279",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1995",
  "framer-motion": "/framer-motion/static-1.69",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9436",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "portals-platform-lib": "/portals-platform-lib/static-1.649",
  "quartz-config": "/quartz-config/static-1.600",
  "quartz-routing": "/quartz-routing/static-1.252",
  "quick-fetch": "/quick-fetch/static-1.3803",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16519",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.8014",
  "styled-components": "/styled-components/static-2.85",
  "tanstack-table": "/tanstack-table/static-1.52",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4637",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9414",
  "usage-tracker": "/usage-tracker/static-1.7204",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5621",
  "usage-tracker-core": "/usage-tracker-core/static-1.7054",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3295",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3099",
  "quartz-webpack": "/quartz-webpack/static-1.3046",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.79",
  "customer-data-objects": "/customer-data-objects/static-1.7523",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7793",
  "laboratory-lib": "/laboratory-lib/static-3.7028",
  "onboarding-scopes": "/onboarding-scopes/static-1.6332",
  "rpc-client-utils": "/rpc-client-utils/static-1.4513",
  "ui-addon-opt": "/ui-addon-opt/static-4.8253",
  "HeadJS": "/HeadJS/static-2.729",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2989",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "ts-schema": "/ts-schema/static-1.3970",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7545",
  "cssUtils": "/cssUtils/static-1.761",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9693",
  "HubStyle": "/HubStyle/static-2.11620",
  "knowledge-content-types": "/knowledge-content-types/static-1.8427",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.497",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9756",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11015",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8902",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10015",
  "video-components-external": "/video-components-external/static-1.10801",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "jasmine": "/jasmine/static-4.4195",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5833",
  "customer-data-properties": "/customer-data-properties/static-1.51012",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18079",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4955",
  "onboarding-tours": "/onboarding-tours/static-1.16360",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7955",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3537",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8916",
  "user-context": "/user-context/static-1.4969",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.814",
  "hubspotter-http": "/hubspotter-http/static-1.4543",
  "icons": "/icons/static-2.636",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.504",
  "module-federation": "/module-federation/static-1.20",
  "quartz-auth": "/quartz-auth/static-1.497",
  "quartz-head": "/quartz-head/static-1.487",
  "quartz-test": "/quartz-test/static-1.497",
  "quartz-tracking": "/quartz-tracking/static-1.201",
  "ui-fonts": "/ui-fonts/static-1.574",
  "usage-tracker-container": "/usage-tracker-container/static-1.7194",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9296",
  "data-token-picker": "/data-token-picker/static-1.16166",
  "FileManagerLib": "/FileManagerLib/static-1.38779",
  "property-translator": "/property-translator/static-1.5277",
  "atom": "/atom/static-1.4939",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "purchase-motions-components": "/purchase-motions-components/static-1.5600",
  "salesImages": "/salesImages/static-1.522",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5135",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.96",
  "ui-images": "/ui-images/static-2.1121",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3921",
  "floating-ui": "/floating-ui/static-1.53",
  "react-aria": "/react-aria/static-1.63",
  "trellis-assets": "/trellis-assets/static-1.1410",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2762",
  "foundations-theming-base": "/foundations-theming-base/static-1.3264",
  "stylex": "/stylex/static-1.29",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5618",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4343",
  "react-flip-move": "/react-flip-move/static-1.67",
  "bender-build-tools": "/bender-build-tools/static-1.3025",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3736",
  "superstore": "/superstore/static-1.4638",
  "chirp-fetch": "/chirp-fetch/static-1.1752",
  "feedback-loader": "/feedback-loader/static-1.29015",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8562",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8565",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28133",
  "sassPrefix": "/sassPrefix/static-1.153",
  "react-dnd-compat": "/react-dnd-compat/static-1.4489",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2361",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8034",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4520",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11740",
  "content-media-compositions": "/content-media-compositions/static-2.15747",
  "idb-keyval": "/idb-keyval/static-1.41",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4023",
  "magpie-lib": "/magpie-lib/static-1.5463",
  "magpie-types": "/magpie-types/static-1.4923",
  "media-bridge-lib": "/media-bridge-lib/static-1.18689",
  "video-data-lib": "/video-data-lib/static-1.34459",
  "commerce-products-lib": "/commerce-products-lib/static-1.9040",
  "crm-message-bus": "/crm-message-bus/static-1.42578",
  "growth-data-modal": "/growth-data-modal/static-1.5229",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4748",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4574",
  "calling-global-api": "/calling-global-api/static-1.63945",
  "calling-internal-common": "/calling-internal-common/static-1.31169",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65327",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57621",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3688",
  "crm-links": "/crm-links/static-1.6140",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12882",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7949",
  "external-options-client-types": "/external-options-client-types/static-1.4049",
  "file-manager-components": "/file-manager-components/static-1.23139",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6743",
  "google-libphonenumber": "/google-libphonenumber/static-1.35",
  "hs-entities": "/hs-entities/static-1.555",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3484",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4113",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.501",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3580",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48242",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3854",
  "property-value-citations": "/property-value-citations/static-1.1626",
  "pulse": "/pulse/static-1.396",
  "smart-property-lib": "/smart-property-lib/static-1.6225",
  "tiered-pricing": "/tiered-pricing/static-1.940",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10862",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2941",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1485",
  "navigation-components": "/navigation-components/static-1.17509",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.426",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7396",
  "ui-universal-auth": "/ui-universal-auth/static-1.8790",
  "batch-promise": "/batch-promise/static-1.1420",
  "navigation-messaging": "/navigation-messaging/static-1.6836",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17197",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9643",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4890",
  "audio-components": "/audio-components/static-1.5710",
  "FileManagerCore": "/FileManagerCore/static-1.38638",
  "FileManagerImages": "/FileManagerImages/static-1.36290",
  "video-components": "/video-components/static-1.12804",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.677",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4368",
  "nav-client-types": "/nav-client-types/static-1.2226",
  "purchase-motions-api": "/purchase-motions-api/static-1.5603",
  "self-service-api": "/self-service-api/static-1.10111",
  "signup-constants": "/signup-constants/static-1.18553",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7904",
  "trials-service-types": "/trials-service-types/static-1.3769",
  "usage-tracker-public": "/usage-tracker-public/static-1.7015",
  "chatspot-core": "/chatspot-core/static-1.20634",
  "ContentUtils": "/ContentUtils/static-1.67841",
  "copilot-toolkit": "/copilot-toolkit/static-1.10723",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6450",
  "reactive-lib": "/reactive-lib/static-1.594",
  "simple-logging-lib": "/simple-logging-lib/static-1.2919",
  "commerce-permissions": "/commerce-permissions/static-1.632",
  "customer-data-tracking": "/customer-data-tracking/static-1.6751",
  "products-iframe-lib": "/products-iframe-lib/static-1.7529",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10027",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.207",
  "calling-error-reporting": "/calling-error-reporting/static-1.31175",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10908",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6410",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.453",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7118",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8783",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4031",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3898",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6648",
  "persist-promise": "/persist-promise/static-1.3577",
  "directed-graph": "/directed-graph/static-1.808",
  "event-emitter": "/event-emitter/static-1.816",
  "fast-json-patch": "/fast-json-patch/static-1.60",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5419",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9728",
  "fsm": "/fsm/static-1.3600",
  "policy-lib": "/policy-lib/static-1.6648",
  "react-tinymce": "/react-tinymce/static-1.54823",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9791",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53949",
  "tinymce-plugins": "/tinymce-plugins/static-1.57063",
  "tinymce-themes": "/tinymce-themes/static-1.55919",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1513",
  "user-context-client": "/user-context-client/static-1.4482",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.585",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4400",
  "video-embed": "/video-embed/static-1.35293",
  "content-icons-ui": "/content-icons-ui/static-1.2185",
  "social-insights-client-types": "/social-insights-client-types/static-1.21604",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3050",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4678",
  "integrations-lib": "/integrations-lib/static-1.15642",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35230",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3507",
  "highcharts": "/highcharts/static-8.101",
  "trellis-story-utils": "/trellis-story-utils/static-1.4389",
  "storybook-react": "/storybook-react/static-1.30",
  "hub-http-contrib": "/hub-http-contrib/static-1.2912",
  "interframe": "/interframe/static-3.4632",
  "tinymce-data": "/tinymce-data/static-1.40034",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5082",
  "codemirror": "/codemirror/static-5.92",
  "layout-dnd-components": "/layout-dnd-components/static-1.12178",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11153",
  "react-codemirror": "/react-codemirror/static-1.10495",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14402",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8960",
  "outpost": "/outpost/static-1.4068",
  "flux-actions": "/flux-actions/static-1.322",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13057",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5461",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7656",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10243",
  "rxjs": "/rxjs/static-5.10",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67916",
  "layout-data-lib": "/layout-data-lib/static-1.9478",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2871",
  "advanced-menus-core": "/advanced-menus-core/static-1.14915",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11883",
  "ExportDialog": "/ExportDialog/static-6.10258",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33640",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14914",
  "simple-menus-lib": "/simple-menus-lib/static-1.16431"
}
};
